import {
  Arg,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  Metadata,
  pick,
} from '../../../../../utils/spds/metadata';
import Super from '../../../core/base.gjs';
import styles from './trigger.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

const METADATA = Metadata.define({
  description: 'Trigger button for dropdown menu',
  extends: [
    pick(COMPONENT_STATE_ARGS, ['autofocus']),
    pick(CONTAINER_ARGS, ['fitContent', 'fitContentHeight', 'fitContentWidth', 'inline']),
  ],
  meta: {
    button: Arg.component({ description: 'Button component to render as trigger' }),
  },
  name: 'Dropdown Trigger',
});

export default class SpdsActionButtonDropdownTrigger extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-action-button-dropdown-trigger';
  classesToMap = ['disabled', 'open'];
  styles = styles;

  <template>
    <@button
      @autofocus={{@autofocus}}
      @disabled={{@disabled}}
      @fitContent={{@fitContent}}
      @fitContentHeight={{@fitContentHeight}}
      @fitContentWidth={{@fitContentWidth}}
      @inline={{@inline}}
      @size={{@size}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      aria-haspopup="menu"
      class={{this.classes}}
      data-test-spds-action-button-dropdown-trigger
      ...attributes
    >
      {{#if @icon}}
        {{svgJar
          @icon
          class="spds-action-button-dropdown-trigger-icon"
          data-test-spds-action-button-trigger-icon=""
        }}
      {{/if}}
      {{yield}}
      {{svgJar "dropdown-caret" class="spds-action-button-dropdown-trigger-caret"}}
    </@button>
  </template>
}

export const ACTION_BUTTON_DROPDOWN_TRIGGER_METADATA = SpdsActionButtonDropdownTrigger.metadata;
